import {
  Button,
  CircularProgress,
  Divider,
  Fab,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import {element} from 'prop-types';
import React, {useEffect, useRef, useState} from 'react';

import SaveIcon from '@material-ui/icons/Save';
import RTL from '../../../../components/RTL';
import province from './../../../province';
import car from './../../../car';
import bar from './../../../bar';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import Autocomplete, {createFilterOptions} from '@material-ui/lab/Autocomplete';
import {v4 as uuidv4} from 'uuid';
import moment from 'moment';
import jMoment from 'moment-jalaali';
import JalaliUtils from '@date-io/jalaali';
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import RemoveIcon from '@material-ui/icons/Remove';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import {Loading, showSnackbar} from 'redux/Action';
import {useDispatch, useSelector} from 'react-redux';
import {axios} from './../../../../axios';
import theme from 'theme';
import {isNumber} from 'validate.js';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.6em',
    },

    '*::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 3px rgba(0,0,0,0.00)',
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: '#192A56',
      // outline: '5px solid slategrey',
      borderRadius: 4,
    },
    '.MuiAutocomplete-option[data-focus=true]': {
      backgroundColor: '#27314F',
      color: 'white',
    },
  },
  imageContainer: {
    width: 140,
    height: 140,
    margin: 'auto',
    position: 'relative',
    overflow: 'unset',
  },
  inputBtn: {
    marginTop: theme.spacing(4),
    width: '100%',
  },
  margin: {
    left: 70,
    position: 'absolute',
    marginTop: -20,
  },
  imageButton: {
    position: 'absolute',

    left: -15,
    bottom: -10,
  },
  image: {
    width: 110,
    height: 110,
  },
  input: {
    marginTop: theme.spacing(4),
    width: '100%',
  },
  imageInput: {
    display: 'none',
  },
  divider: {
    opacity: '0.1',
    marginLeft: '25%',
    marginRight: '25%',
    width: '50%',
    alignItems: 'center',
    backgroundColor: '#273c75',
    height: 1,
  },
  submitButtonIcon: {
    marginLeft: theme.spacing(2),
  },
  wrapper: {
    position: 'relative',
    width: '100%',
  },
  buttonProgress: {
    color: '#121E3E',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: -12,
  },
}));
var staff = [];
const FormNew = (props) => {
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'));
  const classes = useStyles();
  const [Allcities, setAllcities] = useState([]);
  const [AllEmployee, setAllEmployee] = useState([]);

  const [AllTruck_types, setTruck_types] = useState([]);
  const [AllShipment_type, setShipment_type] = useState([]);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.token);
  const isLoading = useSelector((state) => state.isLoading);
  const [showAdd, setShowAdd] = useState(false);
  const current_role = useSelector((state) => state.role);




  const [employeeSel, setemployeeSel] = useState('');
  const [employeeSelNameSel, setemployeeSelNameSel] = useState('');

  const [AutoCompEmployeeSel, setAutoCompEmployeeSel] = useState('');
  const [loadingButton, setLoadingButton] = useState('');

  const [citySel, setCitySel] = useState('');
  let Pr_inventory = useSelector((state) => state.permission);
  const UserDefault = useSelector((state) => state.userCurrent);

  
  const initialState=[
    {
      origin_city_id: {
        value:
           UserDefault?.staff == undefined
            ? ''
            :UserDefault?.staff?.company?.id == 765 ?'': UserDefault?.staff?.company?.city?.id,
        error: '',
        title:
        UserDefault?.staff == undefined
        ? ''
            :UserDefault?.staff?.company?.id == 765 ?'': UserDefault?.staff?.company?.city?.get_province?.name +
              ' ' +
              UserDefault?.staff?.company?.city?.name,
      },
      dest_city_id: {
        value: '',
        error: '',
        title: '',
      },
      truck_model_ids: {
        value: [],
        error: '',
        title: '',
        text: ''
      },

      shipment_type: {
        value: '',
        error: '',
        // title: '',
        // text: '',
      },
      staff_id: {
        value: '',
        error: '',
        title: '',
        text: '',
      },
      tonnage: {
        value: '',
        error: '',
      },
      num: {
        value: '',
        error: '',
      },
      desc: {
        value: '',
        error: '',
        CHARACTER_LIMIT: 256,
      },
    },
  ];
  const defaultFilterOptions = createFilterOptions();
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  var persianNumbers = [
      /۰/g,
      /۱/g,
      /۲/g,
      /۳/g,
      /۴/g,
      /۵/g,
      /۶/g,
      /۷/g,
      /۸/g,
      /۹/g,
    ],
    arabicNumbers = [
      /٠/g,
      /١/g,
      /٢/g,
      /٣/g,
      /٤/g,
      /٥/g,
      /٦/g,
      /٧/g,
      /٨/g,
      /٩/g,
    ],
    fixNumbers = function(str) {
      if (typeof str === 'string') {
        for (var i = 0; i < 10; i++) {
          str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
        }
      }
      return str;
    };

  const [values, setValues] = useState(initialState);
  const [submitKey, setSubmitKey] = useState(false);

  useEffect(() => {
    let newArr = [...values];
    newArr[0].origin_city_id = {
      value:
      UserDefault?.staff == undefined
      ? ''
          :UserDefault?.staff?.company?.id == 765?'':  UserDefault?.staff?.company?.city?.id,
      error: '',
      title:
           UserDefault?.staff == undefined
          ? ''
          :UserDefault?.staff?.company?.id == 765 ?'': UserDefault?.staff?.company?.city?.get_province?.name +
            ' ' +
            UserDefault?.staff?.company?.city?.name,
    };
    setValues(newArr);
  }, [UserDefault]);

  useEffect(() => {
    // start
    if (props.newData[props.newData.length - 1]?.full_name != undefined) {
      UpdateStaff();
      dispatch(Loading());
    }
  }, [props.newData]);

  const Get_Component = async () => {
    try {
      const res = await axios.get('shipments/create', {
        headers: headers,
      });

      if (
        current_role == 'Super-Admin' ||
        Pr_inventory?.indexOf('shipments.insertBy') !== -1
      ) {
        setAllEmployee(res.data.staff);
      }

      let dataCity = res.data.cities;
      let final_City = [];
      dataCity.forEach((obj, i) => {
        final_City = [
          ...final_City,
          {
            id: obj.id,
            province_id: obj.province_id,
            county_id: obj.county_id,
            // name: obj.get_province?.name + ' ' + obj.name,
            name: obj.name + ' ' + obj.get_province?.name,
          },
        ];
      });
      setAllcities(final_City);
      //AllEmployee

      // let dataTruck=res.data.truck_types;

      //   let final_Trucks = [];
      //   dataTruck.forEach((obj, i) => {
      //     final_Trucks = [
      //       ...final_Trucks,
      //       {
      //         name:obj.truck_type?.name +" "+obj.name
      //       },
      //     ];
      //   });

      setTruck_types(res.data.truck_types);

      setShipment_type(res.data.shipment_type);
      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
    }
  };

  const UpdateStaff = async () => {
    try {
      const res = await axios.get('shipments/create', {
        headers: headers,
      });

      if (
        current_role == 'Super-Admin' ||
        Pr_inventory?.indexOf('shipments.insertBy') !== -1
      ) {
        setAllEmployee(res.data.staff);
        console.clear();
        if (props.id === '') {
          setemployeeSel(props.newData[props.newData.length - 1]?.staff?.id);
          setemployeeSelNameSel(
            props.newData[props.newData.length - 1].full_name
          );
          setAutoCompEmployeeSel(
            props.newData[props.newData.length - 1].full_name
          );
        } else {
          let vals = [...values];
          vals[props.id]['staff_id'].value =
            props.newData[props.newData.length - 1]?.staff?.id;
          vals[props.id]['staff_id'].text =
            props.newData[props.newData.length - 1].full_name;

          vals[props.id]['staff_id'].title =
            props.newData[props.newData.length - 1].full_name;
          setValues(vals);
          setemployeeSel(props.newData[props.newData.length - 1]?.staff?.id);
          setemployeeSelNameSel(
            props.newData[props.newData.length - 1].full_name
          );
          setAutoCompEmployeeSel(
            props.newData[props.newData.length - 1].full_name
          );
        }

        props.handleChangeId('');
      }

      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
    }
  };

  useEffect(() => {
    Get_Component();
    dispatch(Loading());
  }, []);

  const handleRemoveFields = (i) => {
    let val = [...values];

    val.splice(i, 1);
    setValues(val);
    let lastElement = values.slice(i - 1);
    // alert(JSON.stringify(lastElement['0']))
    if (
      lastElement['0'].origin_city_id.value != '' &&
      lastElement['0'].origin_city_id.value != undefined &&
      lastElement['0'].dest_city_id.value != '' &&
      lastElement['0'].dest_city_id.value != undefined &&
      lastElement['0'].truck_model_ids.value != '' &&
      lastElement['0'].truck_model_ids.value != undefined
      // lastElement['0'].shipment_type_id.value != '' &&
      // lastElement['0'].shipment_type_id.value != undefined
    ) {
      setShowAdd(true);
    } else {
      setShowAdd(false);
    }
  };

  const InsertShipment = async () => {
    setLoadingButton(true);
    let final_values = [];

    values.forEach((obj, i) => {
      let trucks = [];

      let dataTrucks = obj.truck_model_ids.value;

      if (dataTrucks.length > 0
      ) {
        dataTrucks.forEach(element => {
          trucks.push(parseInt(element?.id))
        });
      }
      final_values = [
        ...final_values,
        {
          staff_id: obj.staff_id.value ? obj.staff_id.value : '',
          origin_city_id: obj.origin_city_id.value,
          dest_city_id: obj.dest_city_id.value,
          truck_model_ids:trucks,
          shipment_type: obj.shipment_type.value,
          tonnage: obj.tonnage.value,
          num: obj.num.value,
          desc: obj.desc.value,
        },
      ];
    });

    // setFinal_Values(Fvals);

    try {
      const res = await axios.post(
        'shipments',
        {
          shipments: final_values,
        },
        {
          headers: headers,
        }
      );
      dispatch(showSnackbar(true, 'success', 'بار با موفقیت ثبت شد'));
     
      setSubmitKey(s => !s);

      setValues([...initialState]);

      setCitySel('');
      setAutoCompEmployeeSel('');
      setemployeeSelNameSel('');
      setemployeeSel('');
      // window.location.reload();
      //dispatch(Loading());
      setLoadingButton(false);
    } catch (e) {
      //  dispatch(Loading());
      setLoadingButton(false);

      if (e.response.status === 422) {
        const er = e.response.data.errors;
        let er_keys = Object.keys(er);
        let vals = [...values];
        er_keys.forEach((element) => {
          let spilts = element.split('.');
          vals[spilts['1']][spilts['2']].error = er[element][0];
        });
        setValues(vals);
      }
    }
  };

  const handleChangeEmplyee = function(which) {
    const re = /^[0-9.\b]+$/;
    const rea = /^[0-9.\b]+$/;
    let vals = [...values];
    
    values.map(
      (obj, i) => (
        (vals[i][which].error = ''),
        (vals[i]['origin_city_id'].error = ''),
        (vals[i][which].value = employeeSel),
        (vals[i]['origin_city_id'].value =
          citySel?.id != 765 && citySel!='' ? citySel?.city?.id : ''),
        (vals[i][which].title = employeeSelNameSel),
        (vals[i][which].text = employeeSelNameSel),
        (vals[i]['origin_city_id'].title =
          citySel?.id != 765 && citySel!=''
            ? citySel?.city?.name + ' ' + citySel?.city?.get_province?.name
            : '')
      )
    );
    // alert(JSON.stringify(citySel))

    setValues(vals);
  };

  const handleChange = function(i, event, which) {
    const re = /^[0-9.\b]+$/;
    const rea = /^[0-9.\b]+$/;
    let vals = [...values];

    if (which == 'dest_city_id') {
      vals[i][which].error = '';
      vals[i][which].value = event?.id;
      vals[i][which].title = event?.name;

      setValues(vals);
    } else if (which == 'origin_city_id') {
      vals[i][which].error = '';
      vals[i][which].value = event?.id;
      vals[i][which].title = event?.name;

      setValues(vals);
    } 
    
    // else if (which == 'shipment_type_id') {
    //   vals[i][which].error = '';
    //   vals[i][which].value = event?.id;
    //   vals[i][which].title = event?.name;
    //   vals[i][which].text = event?.name;

    //   setValues(vals);
    // }
    
    else if (which == 'staff_id') {
      if (event?.staff?.company?.id == 765 || event=='') {
        vals[i][which].error = '';
        vals[i]['origin_city_id'].title = '';
        vals[i]['origin_city_id'].value = '';
        vals[i]['origin_city_id'].error = '';
      } else {
        vals[i][which].error = '';
        vals[i]['origin_city_id'].title =
          event?.staff?.company?.city?.name +
          ' ' +
          event?.staff?.company?.city?.get_province?.name;
        vals[i]['origin_city_id'].value = event?.staff?.company?.city?.id;
        vals[i]['origin_city_id'].error = '';
      }

      vals[i][which].value = event?.staff?.id;
      vals[i][which].title = event.full_name;
      vals[i][which].text = event.full_name;

      setValues(vals);
    } else if (which == 'truck_model_ids') {
      vals[i][which].error = '';
      vals[i][which].value = event;
      vals[i][which].title = event?.full_name;
      vals[i][which].text = event?.full_name;

      setValues(vals);
    } else if (which == 'desc' || which=='shipment_type') {
      vals[i][which].error = '';

      vals[i][which].value = event.target.value;
      setValues(vals);
    } else if (which == 'tonnage' || which == 'num' ) {
      if (
        fixNumbers(event.target.value) === '' ||
        rea.test(fixNumbers(event.target.value))
      ) {
        vals[i][which].error = '';

        vals[i][which].value = fixNumbers(event.target.value);

        setValues(vals);
      }
    } else {
      if (event.target.value === '' || re.test(event.target.value)) {
        vals[i][which].error = '';

        vals[i][which].value = event.target.value;
        setValues(vals);
      }
    }

    const rowLen = values.length;
    values.map((val, i) => {
      if (rowLen === i + 1) {
        if (
          val.origin_city_id.value != '' &&
          val.origin_city_id.value != undefined &&
          val.dest_city_id.value != '' &&
          val.dest_city_id.value != undefined &&
          val.truck_model_ids.value != '' &&
          val.truck_model_ids.value != undefined
          // val.shipment_type_id.value != '' &&
          // val.shipment_type_id.value != undefined
        ) {
          setShowAdd(true);
        } else {
          setShowAdd(false);
        }
      }
    });
  };

  const handleChangeAutoComplete = function(i, valueChange, which, reason) {
    const re = /^[0-9.\b]+$/;
    const rea = /^[0-9.\b]+$/;
    let vals = [...values];
    let lastElement = values.slice(-1);

    // console.clear();
    if (!isNaN(valueChange)) {
      if (valueChange.length < 12) {
        vals[i][which].text = fixNumbers(valueChange);
      }
    } else {
      vals[i][which].text = fixNumbers(valueChange);
    }
    if (reason != 'reset') {
      props.handleChangeData(fixNumbers(valueChange));
      props.handleChangeId(i);
    }

    // if (i > 0) {
    //   vals[i][which].text = lastElement[0].which?.title;
    // }

    // if (props.newData[props.newData.length - 1]?.staff != undefined) {
    //   vals[props.id]['staff_id'].text =
    //     props.newData[props.newData.length - 1]?.staff?.full_name;
    // }
    // if(valueChange=='' && props.newData[props.newData.length - 1]?.full_name != undefined)

    if (valueChange == '' && vals[i][which].title != '') {
      vals[i][which].text = vals[i][which].title;

    }
    setValues(vals);
    //before//
    // let lastElement = values.slice(-1);

    // if (!isNaN(valueChange)) {
    //   if (valueChange.length < 12) {
    //     vals[i][which].text = fixNumbers(valueChange);
    //   }
    // } else {
    //   vals[i][which].text = fixNumbers(valueChange);
    // }
    // props.handleChangeData(fixNumbers(valueChange));
    // props.handleChangeId(i);

    // if (i > 0) {
    //   vals[i][which].text = lastElement[0].which?.title;
    // }

    // if (props.newData[props.newData.length - 1]?.staff != undefined) {
    //   vals[props.id]['staff_id'].text =
    //     props.newData[props.newData.length - 1]?.staff?.full_name;
    // }
    // setValues(vals);
    //end before
    // }
    const rowLen = values.length;
    values.map((val, i) => {
      if (rowLen === i + 1) {
        if (
          val.origin_city_id.value != '' &&
          val.origin_city_id.value != undefined &&
          val.dest_city_id.value != '' &&
          val.dest_city_id.value != undefined &&
          val.truck_model_ids.value != '' &&
          val.truck_model_ids.value != undefined
          // val.shipment_type_id.value != '' &&
          // val.shipment_type_id.value != undefined
        ) {
          setShowAdd(true);
        } else {
          setShowAdd(false);
        }
      }
    });
  };
  const buttonOption = (
    <Button
      fullWidth
      // className={(classes.input, classes.inputBtn)}
      variant="contained"
      color="secondary"
      size="large"
      onClick={(e) => {
        props.showModal();
        e.stopPropagation();
      }}
    >
      یافت نشد! ثبت کارمند جدید
    </Button>
  );

  const createUI = function() {
    return values.map((obj, i) => (
      <>
        {current_role == 'Super-Admin' ||
        Pr_inventory?.indexOf('shipments.insertBy') !== -1 ? (
          <Grid
            container
            spacing={3}
            style={
              values.length - 1 == i
                ? {
                    backgroundColor: '#f7f7f782',
                    marginTop: 8,
                    borderRadius: 20,
                  }
                : {}
            }
          >
            <Grid item xs={12} sm={6} style={{paddingBottom: 0, paddingTop: 0}}>
              <Autocomplete
                noOptionsText="همچنین شهری وجود ندارد"
                options={Allcities}
                // groupBy={(option) => option.get_province?.name}
                disabled={props.statusModal}

                getOptionLabel={(option) => option.name || ''}
                id="origin_city_id"
                value={{
                  name: obj['origin_city_id'].title,
                }}
                // PaperComponent={(props) => {
                //   return <Paper style={{ backgroundColor: "#a4b0be",color:"white" }} elevation={8} {...props} />;
                // }}
                onChange={(e, v) =>
                  v != null
                    ? handleChange(i, v, 'origin_city_id')
                    : handleChange(i, '', 'origin_city_id')
                }
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    autoFocus={ values.length == parseInt(i+1) && values.length >1  ? true : false}
                    label="مبدا "
                    variant="outlined"
                    error={Boolean(obj['origin_city_id'].error)}
                    helperText={obj['origin_city_id'].error}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} style={{paddingBottom: 0, paddingTop: 0}}>
              <Autocomplete

                disabled={props.statusModal}
                noOptionsText="همچنین شهری وجود ندارد"
                options={Allcities}
                // groupBy={(option) => option.get_province?.name}

                getOptionLabel={(option) => option.name || ''}
                id="dest_city_id"
                value={{
                  name: obj['dest_city_id'].title,
                }}
                // PaperComponent={(props) => {
                //   return <Paper style={{ backgroundColor: "#a4b0be",color:"white" }} elevation={8} {...props} />;
                // }}
                onChange={(e, v) =>
                  v != null
                    ? handleChange(i, v, 'dest_city_id')
                    : handleChange(i, '', 'dest_city_id')
                }
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    // autoFocus={obj['dest_city_id'].title=='' && values.length == parseInt(i+1) && values.length >1 ? true : false}
                    label="مقصد "
                    
                    variant="outlined"
                    error={Boolean(obj['dest_city_id'].error)}
                    helperText={obj['dest_city_id'].error}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={12} style={{paddingBottom: 0, paddingTop: 0}}>
              <Autocomplete
                
                noOptionsText="همچنین ماشینی وجود ندارد"
                options={AllTruck_types}
                getOptionLabel={(option) => option.full_name || ''}
                id="truck_model_ids"
                
 
                multiple={true}
                value={obj['truck_model_ids'].value}

                // defaultValue={obj['truck_model_ids'].value!=''?obj['truck_model_ids'].value:[]}
                // defaultValue={{
                //   full_name: [],
                // }}
                key={`truck_model_ids${i}`}
                onChange={(e, v) =>
                  v != null
                    ? handleChange(i, v, 'truck_model_ids')
                    : handleChange(i, '', 'truck_model_ids')
                }
                inputValue={obj['truck_model_ids'].text || ''}
                onInputChange={(event, value, reason) => {
                  // if (reason !== 'reset') {
                  handleChangeAutoComplete(
                    i,
                    fixNumbers(value),
                    'truck_model_ids',
                    reason
                  );

                  
                }}
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    label="نوع ماشین "
                    onBlur={(event)=> event.preventDefault()} 
                    variant="outlined"
                    error={Boolean(obj['truck_model_ids'].error)}
                    helperText={obj['truck_model_ids'].error}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={4} style={{paddingBottom: 0, paddingTop: 0}}>
              {/* <Autocomplete
                noOptionsText="همچنین باری وجود ندارد"
                options={AllShipment_type}
               
                getOptionLabel={(option) => option.name || ''}
                id="shipment_type_id"
                // value={inputField}
                defaultValue={{
                  name: '',
                }}
                onChange={(e, v) =>
                  v != null
                    ? handleChange(i, v, 'shipment_type_id')
                    : handleChange(i, '', 'shipment_type_id')
                }
                inputValue={obj['shipment_type_id'].text || ''}
                onInputChange={(event, value, reason) => {
                  // if (reason !== 'reset') {
                  handleChangeAutoComplete(
                    i,
                    fixNumbers(value),
                    'shipment_type_id',
                    reason
                  );

                  // }
                }}
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    label="نوع بار "
                    placeholder="اختیاری"
                    variant="outlined"
                    error={Boolean(obj['shipment_type_id'].error)}
                    helperText={obj['shipment_type_id'].error}
                  />
                )}
              /> */}


<TextField
                error={Boolean(obj['shipment_type'].error)}
                helperText={obj['shipment_type'].error}
                className={classes.input}
                name="shipment_type"
                label="نوع بار "
                placeholder="اختیاری"
                variant="outlined"
                // style={{ marginTop: 40 }}
                value={obj['shipment_type'].value}
                onChange={(e) => handleChange(i, e, 'shipment_type')}
              />
            </Grid>

            <Grid item xs={12} sm={2} style={{paddingBottom: 0, paddingTop: 0}}>
              <TextField
                error={Boolean(obj['tonnage'].error)}
                helperText={obj['tonnage'].error}
                className={classes.input}
                name="tonnage"
                label="تناژ"
                placeholder="اختیاری"
                variant="outlined"
                // style={{ marginTop: 40 }}
                value={obj['tonnage'].value}
                onChange={(e) => handleChange(i, e, 'tonnage')}
              />
            </Grid>

            <Grid item xs={12} sm={2} style={{paddingBottom: 0, paddingTop: 0}}>
              <TextField
                error={Boolean(obj['num'].error)}
                helperText={obj['num'].error}
                className={classes.input}
                label="تعداد"
                placeholder="اختیاری"
                name="num"
                value={obj['num'].value}
                onChange={(e) => handleChange(i, e, 'num')}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={4} style={{paddingBottom: 0, paddingTop: 0}}>
              <Autocomplete
                noOptionsText={
                  <Button
                    fullWidth
                    // className={(classes.input, classes.inputBtn)}
                    variant="contained"
                    color="secondary"
                    size="large"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    No results! Click me
                  </Button>
                }
                options={AllEmployee}
                getOptionLabel={(option) => option.full_name || ''}
                id="staff_id"
                defaultValue={{
                  full_name: '',
                }}
                // value={{
                //   full_name: obj['staff_id'].title,
                // }}
                renderOption={(option) => option.full_name}
                filterOptions={(options, state) => {
                  const results = defaultFilterOptions(options, state);

                  if (results.length === 0) {
                    return [
                      {
                        full_name: (
                          <Button
                            fullWidth
                            // className={(classes.input, classes.inputBtn)}
                            variant="contained"
                            color="secondary"
                            size="large"
                            onClick={(e) => {
                              props.showModal();
                              e.stopPropagation();
                            }}
                          >
                            یافت نشد! ثبت کارمند جدید
                          </Button>
                        ),
                      },
                    ];
                  }

                  return results;
                }}
                key={obj['staff_id'].value}
                onChange={(e, v) =>
                  v != null
                    ? handleChange(i, v, 'staff_id')
                    : handleChange(i, '', 'staff_id')
                }
                inputValue={obj['staff_id'].text || ''}
                onInputChange={(event, value, reason) => {
                  // if (reason !== 'reset') {
                  handleChangeAutoComplete(
                    i,
                    fixNumbers(value),
                    'staff_id',
                    reason
                  );
                  // }
                }}
                //  onClose={(e)=>  handleChangeAutoComplete(i, '', 'staff_id')}
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    label="کاربر ثبت کننده"
                    variant="outlined"
                    error={Boolean(obj['staff_id'].error)}
                    helperText={obj['staff_id'].error}
                  />
                )}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={11}
              style={{paddingBottom: 0, paddingTop: 0}}
            >
              <TextField
                error={Boolean(obj['desc'].error)}
                helperText={
                  obj['desc'].error
                    ? obj['desc'].error
                    : `${obj['desc'].value.length}/${obj['desc'].CHARACTER_LIMIT}`
                }
                className={classes.input}
                label="توضیحات"
                placeholder="اختیاری"
                onKeyDown={(ev) => {
                  if (ev.key === 'Tab') {
                    addClick();
                    ev.preventDefault();
                  }
                }}
                name="desc"
                inputProps={{
                  maxlength: `${obj['desc'].CHARACTER_LIMIT}`,
                }}
                value={obj['desc'].value}
                onChange={(e) => handleChange(i, e, 'desc')}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={1} style={{paddingBottom: 0, paddingTop: 0}}>
              <Grid
                className={classes.input}
                style={
                  isSmall
                    ? {marginTop: 10, width: '100%', display: 'inline-block'}
                    : {width: '100%', display: 'inline-block'}
                }
              >
                <IconButton
                  style={
                    values.length === 1
                      ? isSmall
                        ? {
                            backgroundColor: '#e7d7d7',
                            width: '30%',
                            opacity: 0.4,
                            borderRadius: 15,
                            color: '#ff767577',
                          }
                        : {
                            backgroundColor: 'transparent',
                            width: '50%',
                            color: '#ff767577',
                          }
                      : isSmall
                      ? {
                          backgroundColor: '#ff767577',
                          width: '30%',
                          borderRadius: 15,
                          color: 'black',
                        }
                      : {
                          backgroundColor: 'transparent',
                          width: '50%',
                          color: '#c0392b',
                        }
                  }
                  disabled={values.length === 1}
                  onClick={() => {
                    handleRemoveFields(i);
                  }}
                >
                  {/* <RemoveCircleOutlineIcon /> */}
                  <Typography
                    style={
                      values.length === 1
                        ? {
                            backgroundColor: 'transparent',
                            width: '50%',
                            color: '#ff767577',
                          }
                        : {
                            backgroundColor: 'transparent',
                            width: '50%',
                            color: '#c0392b',
                          }
                    }
                  >
                    حذف
                  </Typography>
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Grid
            style={
              values.length - 1 == i
                ? {
                    backgroundColor: '#f7f7f782',
                    marginTop: 8,
                    borderRadius: 20,
                  }
                : {}
            }
            spacing={2}
            container
            justify="space-around"
          >
            <Grid item xs={12} sm={6} style={{paddingBottom: 0, paddingTop: 0}}>
              <Autocomplete
                noOptionsText="همچنین شهری وجود ندارد"
                options={Allcities}
                // groupBy={(option) => option.get_province?.name}
                disabled={props.statusModal}

                getOptionLabel={(option) => option.name || ''}
                id="origin_city_id"
                value={{
                  name: obj['origin_city_id'].title,
                }}
                // PaperComponent={(props) => {
                //   return <Paper style={{ backgroundColor: "#a4b0be",color:"white" }} elevation={8} {...props} />;
                // }}
                onChange={(e, v) =>
                  v != null
                    ? handleChange(i, v, 'origin_city_id')
                    : handleChange(i, '', 'origin_city_id')
                }
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    label="مبدا "
                    autoFocus={values.length == parseInt(i+1) && values.length >1   ? true : false}
                    variant="outlined"
                    error={Boolean(obj['origin_city_id'].error)}
                    helperText={obj['origin_city_id'].error}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} style={{paddingBottom: 0, paddingTop: 0}}>
              <Autocomplete
                noOptionsText="همچنین شهری وجود ندارد"
                options={Allcities}
                // groupBy={(option) => option.get_province?.name}
                disabled={props.statusModal}
                getOptionLabel={(option) => option.name || ''}
                id="dest_city_id"
                value={{
                  name: obj['dest_city_id'].title,
                }}
                // PaperComponent={(props) => {
                //   return <Paper style={{ backgroundColor: "#a4b0be",color:"white" }} elevation={8} {...props} />;
                // }}
                onChange={(e, v) =>
                  v != null
                    ? handleChange(i, v, 'dest_city_id')
                    : handleChange(i, '', 'dest_city_id')
                }
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    label="مقصد "
                    // autoFocus={obj['dest_city_id'].title=='' && values.length == parseInt(i+1) && values.length >1 ? true : false}
                    variant="outlined"
                    error={Boolean(obj['dest_city_id'].error)}
                    helperText={obj['dest_city_id'].error}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={12} style={{paddingBottom: 0, paddingTop: 0}}>
              <Autocomplete
                noOptionsText="همچنین ماشینی وجود ندارد"
                options={AllTruck_types}
                getOptionLabel={(option) => option.full_name || ''}
                id="truck_model_ids"
                // defaultValue={{
                //   full_name: '',
                // }}
                multiple={true}
                defaultValue={obj['truck_model_ids'].value!=''?obj['truck_model_ids'].value:[]}

                // PaperComponent={(props) => {
                //   return <Paper style={{ backgroundColor: "#a4b0be",color:"white" }} elevation={8} {...props} />;
                // }}
                key={`truck_model_ids${i}`}
                onChange={(e, v) =>
                  v != null
                    ? handleChange(i, v, 'truck_model_ids')
                    : handleChange(i, '', 'truck_model_ids')
                }
                 
                inputValue={obj['truck_model_ids'].text || ''}
                onInputChange={(event, value, reason) => {
                  // if (reason !== 'reset') {
                  handleChangeAutoComplete(
                    i,
                    fixNumbers(value),
                    'truck_model_ids',
                    reason
                  ); 

                  // }
                }}
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    label="نوع ماشین "
                    variant="outlined"
                    onBlur={(event)=> event.preventDefault()} 
                    error={Boolean(obj['truck_model_ids'].error)}
                    helperText={obj['truck_model_ids'].error}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={4} style={{paddingBottom: 0, paddingTop: 0}}>
              {/* <Autocomplete
                noOptionsText="همچنین باری وجود ندارد"
                options={AllShipment_type}
                // PaperComponent={(props) => {
                //   return <Paper style={{ backgroundColor: "#a4b0be",color:"white" }} elevation={8} {...props} />;
                // }}
                getOptionLabel={(option) => option.name || ''}
                id="shipment_type_id"
                // value={inputField}
                defaultValue={{
                  name: '',
                }}
                onChange={(e, v) =>
                  v != null
                    ? handleChange(i, v, 'shipment_type_id')
                    : handleChange(i, '', 'shipment_type_id')
                }
                inputValue={obj['shipment_type_id'].text || ''}
                onInputChange={(event, value, reason) => {
                  // if (reason !== 'reset') {
                  handleChangeAutoComplete(
                    i,
                    fixNumbers(value),
                    'shipment_type_id',
                    reason
                  );

                  // }
                }}
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    label="نوع بار "
                    placeholder="اختیاری"
                    variant="outlined"
                    error={Boolean(obj['shipment_type_id'].error)}
                    helperText={obj['shipment_type_id'].error}
                  />
                )}
              /> */}
     <TextField
                error={Boolean(obj['shipment_type'].error)}
                helperText={obj['shipment_type'].error}
                className={classes.input}
                name="shipment_type"
                label="نوع بار "
                placeholder="اختیاری"
                variant="outlined"
                // style={{ marginTop: 40 }}
                value={obj['shipment_type'].value}
                onChange={(e) => handleChange(i, e, 'shipment_type')}
              />
              
            </Grid>

            <Grid item xs={12} sm={2} style={{paddingBottom: 0, paddingTop: 0}}>
              <TextField
                error={Boolean(obj['tonnage'].error)}
                helperText={obj['tonnage'].error}
                className={classes.input}
                name="tonnage"
                label="تناژ"
                placeholder="اختیاری"
                variant="outlined"
                // style={{ marginTop: 40 }}
                value={obj['tonnage'].value}
                onChange={(e) => handleChange(i, e, 'tonnage')}
              />
            </Grid>

            <Grid item xs={12} sm={2} style={{paddingBottom: 0, paddingTop: 0}}>
              <TextField
                error={Boolean(obj['num'].error)}
                helperText={obj['num'].error}
                className={classes.input}
                label="تعداد"
                placeholder="اختیاری"
                name="num"
                value={obj['num'].value}
                onChange={(e) => handleChange(i, e, 'num')}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={3} style={{paddingBottom: 0, paddingTop: 0}}>
              <TextField
                error={Boolean(obj['desc'].error)}
                helperText={
                  obj['desc'].error
                    ? obj['desc'].error
                    : `${obj['desc'].value.length}/${obj['desc'].CHARACTER_LIMIT}`
                }
                className={classes.input}
                label="توضیحات"
                placeholder="اختیاری"
                onKeyDown={(ev) => {
                  if (ev.key === 'Tab') {
                    addClick();
                    ev.preventDefault();
                  }
                }}
                name="desc"
                inputProps={{
                  maxlength: `${obj['desc'].CHARACTER_LIMIT}`,
                }}
                value={obj['desc'].value}
                onChange={(e) => handleChange(i, e, 'desc')}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={1} style={{paddingBottom: 0, paddingTop: 0}}>
              <Grid
                className={classes.input}
                style={{width: '100%', display: 'inline-block'}}
              >
                <IconButton
                  style={
                    values.length === 1
                      ? {
                          backgroundColor: 'transparent',
                          width: '50%',
                          color: '#ff767577',
                        }
                      : {
                          backgroundColor: 'transparent',
                          width: '50%',
                          color: '#c0392b',
                        }
                  }
                  disabled={values.length === 1}
                  onClick={() => {
                    handleRemoveFields(i);
                  }}
                >
                  {/* <RemoveCircleOutlineIcon /> */}
                  <Typography
                    style={
                      values.length === 1
                        ? {
                            backgroundColor: 'transparent',
                            width: '50%',
                            color: '#ff767577',
                          }
                        : {
                            backgroundColor: 'transparent',
                            width: '50%',
                            color: '#c0392b',
                          }
                    }
                  >
                    حذف
                  </Typography>
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        )}

        <Divider
          container
          style={
            values.length > 1 ? {marginTop: 20, padding: 1} : {display: 'none'}
          }
        />
      </>
    ));
  };

  const submit = function() {
    
    InsertShipment();

    // alert(JSON.stringify(values))
  };

  const addClick = function() {
    let lastElement = values.slice(-1);

    if (showAdd) {
      setValues([
        ...values,
        {
          origin_city_id: {
            // value:
            //   UserDefault?.staff == undefined
            //     ? lastElement[0].origin_city_id?.value == undefined
            //       ? ''
            //       : lastElement[0].origin_city_id?.value
            //     : UserDefault?.staff?.company?.city?.id,
            // error: '',
            // title:
            //   UserDefault?.staff == undefined
            //     ? lastElement[0].origin_city_id?.title == undefined
            //       ? ''
            //       : lastElement[0].origin_city_id?.title
            //     : UserDefault?.staff?.company?.city?.get_province?.name +
            //       ' ' +
            //       UserDefault?.staff?.company?.city?.name,
            value:lastElement[0].origin_city_id?.value,
            title:lastElement[0].origin_city_id?.title,
            error:''

          },
          dest_city_id: {
            value: '',
            error: '',
            title: '',
          },
          truck_model_ids: {
            value: lastElement[0].truck_model_ids?.value,
            error: '',
            title: lastElement[0].truck_model_ids?.title,
            text: lastElement[0].truck_model_ids?.text,
          },

          shipment_type: {
            // value: lastElement[0].shipment_type_id?.value,
            // error: '',
            // title: lastElement[0].shipment_type_id?.title,
            // text: lastElement[0].shipment_type_id?.text,
            value: lastElement[0].shipment_type?.value,
            error: '',
          },
          staff_id: {
            value: lastElement[0].staff_id?.value,
            error: '',
            title: lastElement[0].staff_id?.title,
            text: lastElement[0].staff_id?.text,
          },
          tonnage: {
            value: lastElement[0].tonnage?.value,
            error: '',
          },

          num: {
            value: lastElement[0].num?.value,
            error: '',
          },
          desc: {
            value: lastElement[0].desc?.value,
            error: '',
            CHARACTER_LIMIT: 256,
          },
        },
      ]);
    }
    setShowAdd(false);
  };

  return (
    <RTL>
      {!isLoading ? (
        <Grid item xs={12} sm={12}>
          {current_role == 'Super-Admin' ||
          Pr_inventory?.indexOf('shipments.insertBy') !== -1 ? (
            <Grid container alignItems="center" spacing={isSmall ? 0 : 4}>
              <Grid item xs={12} sm={8}>
                <Autocomplete
                  noOptionsText="همچنین کاربری وجود ندارد"
                  options={AllEmployee}
                  // groupBy={(option) => option.get_province?.name}

                  id="dest_city_id"
                  onChange={(event, value) => {
                    if (value != null) {
                      if (value.staff?.company?.city != undefined) {
                        // setCitySel(value.staff.company.city);
                      setCitySel(value.staff.company);

                      }
                      setemployeeSel(value.staff.id);

                      setemployeeSelNameSel(value.full_name);
                    } else {
                      setemployeeSel('');
                      setCitySel('');

                      setemployeeSelNameSel('');
                    }
                  }}
                  getOptionLabel={(option) => option.full_name || ''}
                  renderOption={(option) => option.full_name}
                  filterOptions={(options, state) => {
                    const results = defaultFilterOptions(options, state);

                    if (results.length === 0) {
                      return [
                        {
                          full_name: (
                            <Button
                              fullWidth
                              // className={(classes.input, classes.inputBtn)}
                              variant="contained"
                              color="secondary"
                              size="large"
                              onClick={(e) => {
                                props.showModal();
                                e.stopPropagation();
                              }}
                            >
                              یافت نشد! ثبت کارمند جدید
                            </Button>
                          ),
                        },
                      ];
                    }

                    return results;
                  }}
                  // onChange={(e, v) =>
                  //   v != null
                  //     ? handleChangeEmplyee(v, "shipment_type_id")
                  //     : handleChangeEmplyee("", "shipment_type_id")
                  // }
                  key={!submitKey?'userEmployeeId':'userEmployee'}
                  inputValue={AutoCompEmployeeSel}
                  onInputChange={(event, value, reason) => {
                    // if (reason !== 'reset') {
                    if (
                      value == '' &&
                      props.newData[props.newData.length - 1]?.full_name !=
                        undefined
                    ) {
                      if (value == '' && reason !== 'reset') {
                        setAutoCompEmployeeSel(fixNumbers(value));
                      } else {
                        setAutoCompEmployeeSel(
                          fixNumbers(
                            props.newData[props.newData.length - 1]?.full_name
                          )
                        );
                      }
                      // props.handleChangeData(fixNumbers(value));
                      // props.handleChangeId('');
                      props.handleChangeData(fixNumbers(value));
                      // props.handleChangeId(props.id);
                    } else {
                      setAutoCompEmployeeSel(fixNumbers(value));
                      props.handleChangeData(fixNumbers(value));
                      // props.handleChangeId(props.id);
                    }

                    // }
                  }}
                  renderInput={(params) => (
                    <TextField
                      className={classes.input}
                      {...params}
                      label="نام کاربر ثبت کننده "
                      variant="outlined"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <Grid
                  className={classes.input}
                  style={{width: '100%', display: 'inline-block'}}
                >
                  <Button
                    onClick={() => handleChangeEmplyee('staff_id')}
                    fullWidth
                    // className={(classes.input, classes.inputBtn)}
                    variant="contained"
                    color="secondary"
                    size="large"
                  >
                    اعمال کاربر به همه
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          ) : (
            <></>
          )}
          {createUI()}
          <Fab
            disabled={!showAdd}
            onClick={() => addClick()}
            size="small"
            color="secondary"
            aria-label="add"
            className={classes.margin}
          >
            <AddCircleOutlineIcon />
          </Fab>

          <div className={classes.wrapper}>
            <Button
              fullWidth
              className={(classes.input, classes.inputBtn)}
              variant="contained"
              color="secondary"
              onClick={() => submit()}
              size="large"
              disabled={loadingButton}
              startIcon={<SaveIcon className={classes.submitButtonIcon} />}
            >
              اعلان بار جدید
            </Button>
            {loadingButton && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </Grid>
      ) : (
        <div className={classes.wrapper}>
          {isLoading && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}
        </div>
      )}
    </RTL>
  );
};

export default FormNew;
